import React from 'react'


export default function ZaloLoginBtn({
                                       onSuccess
                                     }) {

  return (
    <React.Fragment>
      <button
        className="loginBtn loginBtn--google"
        onClick={
          () => {

          }
        }
      >
        Login with Zalo
      </button>
    </React.Fragment>
  )
}